import { DOCS_FORM_NAMES } from "core/consts";
import { ControlledTextarea } from "ds/ui";
import { FormFieldConfig } from "../..";

export const DischargeLetterCardiologyFormSections: FormFieldConfig<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY
>["sections"] = [
  {
    fields: {
      diagnoses: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .diagnosisLabel
            }
            name="diagnoses"
            placeholder=" "
          />
        ),
        position: 1,
      },
      previous_diagnoses: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .previousDiagnosesLabel
            }
            name="previous_diagnoses"
            placeholder=" "
          />
        ),
        position: 2,
      },
    },
    position: 1,
  },
  {
    fields: {
      allergies: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .allergyLabel
            }
            name="allergies"
            placeholder=" "
          />
        ),
        position: 2,
      },
      anamnesis: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .medicalHistoryLabel
            }
            name="anamnesis"
            placeholder=" "
          />
        ),
        position: 1,
      },
      physical_status: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .physicalStatusLabel
            }
            name="physical_status"
            placeholder=" "
          />
        ),
        position: 4,
      },
      social_history: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .socialHistoryLabel
            }
            name="social_history"
            placeholder=" "
          />
        ),
        position: 3,
      },
    },
    position: 2,
  },
  {
    fields: {
      additional_diagnostic_findings: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .furtherDiagnosisLabel
            }
            name="additional_diagnostic_findings"
            placeholder=" "
          />
        ),
        position: 2,
      },
      ecg: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology.ecgLabel
            }
            name="ecg"
            placeholder=" "
          />
        ),
        position: 1,
      },
    },
    position: 3,
    title: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .findingsSectionLabel,
  },
  {
    fields: {
      discharge_medications: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .dischargeMedicationsLabel
            }
            name="discharge_medications"
            placeholder=" "
          />
        ),
        position: 2,
      },
      therapy_and_course: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .therapyAndCourseLabel
            }
            name="therapy_and_course"
            placeholder=" "
          />
        ),
        position: 1,
      },
    },
    position: 4,
  },
];
